import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSEOStore = defineStore('seo', () => {
  const metas = Array.from(document.getElementsByTagName('meta'))
  const findMeta = (key: string) => metas.find((meta) => meta.name === key) as HTMLMetaElement

  const ogTitle = ref<HTMLMetaElement>(findMeta('og:title'))
  const ogDescription = ref<HTMLMetaElement>(findMeta('og:description'))
  const description = ref<HTMLMetaElement>(findMeta('description'))
  const ogImage = ref<HTMLMetaElement>(findMeta('og:image'))
  const twitterCard = ref<HTMLMetaElement>(findMeta('twitter:card'))

  const update = (seo: Seo) => {
    if (seo.title) {
      document.title = seo.title
      ogTitle.value.content = seo.title
    }

    if (seo.description) {
      ogDescription.value.content = seo.description
      description.value.content = seo.description
      twitterCard.value.content = seo.description
    }

    if (seo.image) {
      ogImage.value.content = seo.image.original
    }
  }

  return { update }
})
